// 테마 관리 스토어 — 8가지 테마 정의 + localStorage 영속화
import { create } from 'zustand';

export type ThemeId = 'dark' | 'light' | 'crt' | 'purple' | 'sky' | 'beige' | 'orange' | 'pink';

export interface ThemeMeta {
  id: ThemeId;
  label: string;
  swatch: string; // 대표 색상 (CSS 컬러)
}

export const THEMES: ThemeMeta[] = [
  { id: 'dark',   label: '다크',         swatch: '#00d9a3' },
  { id: 'light',  label: '라이트',       swatch: '#0077bb' },
  { id: 'crt',    label: 'CRT 그린',     swatch: '#00ff41' },
  { id: 'purple', label: '퍼플',         swatch: '#b478ff' },
  { id: 'sky',    label: '스카이',       swatch: '#38bdf8' },
  { id: 'beige',  label: '베이지/블랙',  swatch: '#c8a96e' },
  { id: 'orange', label: '주황',         swatch: '#ff8c00' },
  { id: 'pink',   label: '핑크',         swatch: '#ff69b4' },
];

const STORAGE_KEY = 'fg_theme';

function applyTheme(id: ThemeId) {
  document.documentElement.setAttribute('data-theme', id);
}

interface ThemeState {
  theme: ThemeId;
  setTheme: (id: ThemeId) => void;
}

const saved = (typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null) as ThemeId | null;
const initial: ThemeId = saved ?? 'dark';
if (typeof document !== 'undefined') applyTheme(initial);

export const useThemeStore = create<ThemeState>((set) => ({
  theme: initial,
  setTheme: (id) => {
    applyTheme(id);
    if (typeof localStorage !== 'undefined') localStorage.setItem(STORAGE_KEY, id);
    set({ theme: id });
  },
}));
